import request from '../utils/request'
const baseUrl = process.env.NODE_ENV === 'production' ? '' : '/packmap'
 
export function getStatisticsInfo (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getStatisticsInfo',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getStatisticsInfo1day (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getStatisticsInfo1day',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getInfo7days (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getInfo7days',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}
export function getMonthRecord (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getMonthRecord',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}

export function getebMonthRecord (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getMonthRecord',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}

export function lcebchargerlog (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}

export function lcebchargerlogStatis (parkfieldId) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getStatisticsInfo',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  })
}

export function getDayRecord (parkfieldId, month) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getDayRecord',
    method: 'get',
    params: {
      parkfieldId: parkfieldId,
      yearMonth: month
    }
  })
}

export function getebDayRecord (parkfieldId, month) {
  return request({
    url: baseUrl + '/lcplatelockrecord/getDayRecord',
    method: 'get',
    params: {
      parkfieldId: parkfieldId,
      yearMonth: month
    }
  })
}






// WEBPACK FOOTER //
// ./src/api/lcChargerLog.js